import { Button } from "@tblabs/truffle";


export class DangerButton extends Button
{
    constructor(label: string, action?: (btn: Button) => void)
    {
        super(label);
        this.DisplayInlineBlock();
        this.Class("uk-button uk-button-danger").Style("white-space: nowrap");

        this.OnClick(btn => action?.(btn));
    }
}
